import { BitcoinNetworkType } from 'sats-connect';

export const convertNetworkIdToSatsConnectNetworkType = (networkId: string) => {
  if (networkId === '2') {
    return BitcoinNetworkType.Testnet;
  }

  if (networkId === '3') {
    return BitcoinNetworkType.Signet;
  }

  // fallback to mainnet
  return BitcoinNetworkType.Mainnet;
};
